import { Link } from "react-router-dom"
import { Flex, Form, Radio, Typography } from "antd"

export const ManualPayoutsFormFee = () => {
  return (
    <Flex align="center" gap={16}>
      <Typography.Paragraph style={{ margin: 0 }}>
        Who pays the transaction{" "}
        <Link
          id="GENERATED_ID_MANUALPAYOUTSFORMFEE_LINK_FEE_1"
          target="_blank"
          to="https://www.cryptix.io/service-fees"
        >
          fee
        </Link>
      </Typography.Paragraph>
      <Form.Item
        id="GENERATED_ID_MANUALPAYOUTSFORMFEE_TSX_FORM.ITEM_VOID_1"
        name={"fee_payer"}
      >
        <Radio.Group buttonStyle="solid" defaultValue="merchant" size="small">
          <Radio.Button value="merchant">Merchant</Radio.Button>
          <Radio.Button value="customer">Customer</Radio.Button>
        </Radio.Group>
      </Form.Item>
    </Flex>
  )
}
